import { BaseService } from './BaseService';
import { apiService } from './apiService';
import { RmContentDocument, ThumbnailData } from '../types/rmContent';

export class RmContentService extends BaseService {
  constructor() {
    super('RmContentService', { debug: false });
  }

  /**
   * Get a single RM content document by its public URL
   */
  async getContentByUrl(url: string, language?: string): Promise<RmContentDocument> {
    return this.executeOperation(async () => {
      let endpoint = `/api/content/rm?url=${encodeURIComponent(url)}`;
      if (language) {
        endpoint += `&language=${encodeURIComponent(language)}`;
      }
      return await apiService.get<RmContentDocument>(endpoint);
    }, 'getContentByUrl');
  }

  /**
   * Batch-fetch thumbnail data for multiple URLs
   */
  async getThumbnailsByUrls(urls: string[]): Promise<Record<string, ThumbnailData>> {
    return this.executeOperation(async () => {
      return await apiService.post<Record<string, ThumbnailData>>('/api/content/rm/thumbnails', { urls });
    }, 'getThumbnailsByUrls');
  }

  protected onCircuitBreakerChange(eventType: string, data: any): void {
    this.logDebug(`Circuit breaker event: ${eventType}`, data);
  }

  protected onRetry(error: Error, attempt: number, delay: number, operationName: string): void {
    this.logDebug(`Retrying ${operationName}`, {
      attempt,
      delay,
      error: error.message
    });
  }
}

export const rmContentService = new RmContentService();
